var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"privacy-index page-index"},[_c('Header'),_c('PageTop',{staticClass:"bg-gray",attrs:{"page":"privacy"}}),_c('PrivacyMain'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }